// extracted by mini-css-extract-plugin
export default {"modal":"Oha-z","header":"Pha-z","fields":"Qha-z","error":"Rha-z","disabled":"Sha-z","reminderMsg":"Tha-z","errorMsg":"Uha-z","footer":"Vha-z"};